var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReceipt = function SvgReceipt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A5ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3776AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.5.3.57.2-Setup-/-Company-/-Create-new-project-/-Prices-changed",
    transform: "translate(-672.597015, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext",
    transform: "translate(520.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597015, 40.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "receipt",
    mask: "url(#mask-3)",
    fill: "#E2F2FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 6.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4265619,0.0277867063 C28.1964646,-0.0269307075 27.9543776,0.00260260953 27.7441834,0.111033232 L26.2499994,0.857213772 L26.2499994,0.857213772 L24.743055,0.103741566 C24.4693616,-0.0330951594 24.1472172,-0.0330951594 23.8735238,0.103741566 L22.3477426,0.857821411 L22.3477426,0.857821411 L20.8420134,0.103741566 C20.5674907,-0.0341100303 20.2439668,-0.0341100303 19.969444,0.103741566 L18.4722218,0.855390855 L18.4722218,0.855390855 L16.9865448,0.105564482 C16.7127636,-0.0332322673 16.3895152,-0.0345838285 16.114583,0.101918649 L14.583333,0.85842905 L14.583333,0.85842905 L13.0763886,0.103133927 C12.8022505,-0.033630319 12.4797802,-0.033630319 12.2056421,0.103133927 L10.6944442,0.857213772 L10.6944442,0.857213772 L9.18506925,0.103133927 C8.78461135,-0.0976044262 8.29882971,0.00125815938 8.00868039,0.342543644 C7.85672259,0.523656839 7.77479112,0.753280566 7.77769876,0.989679047 L7.77769876,15.5559982 L19.444444,15.5559982 C20.518331,15.5559982 21.3888884,16.4265556 21.3888884,17.5004426 L21.3888884,23.8198869 C21.3888884,25.6993139 23.3983502,27.2226646 25.2777772,27.2226646 L26.0069439,27.2226646 C27.7520103,27.2226646 29.1666664,25.8080088 29.1666664,24.0629424 L29.1666664,0.972665159 C29.1670216,0.524841775 28.8614349,0.134704432 28.4265619,0.0277867063 Z M24.305555,12.6393316 L16.5581594,12.6393316 C16.0331594,12.6393316 15.5798608,12.2358594 15.5567705,11.7108594 C15.5448275,11.4457276 15.6417928,11.1872381 15.8251656,10.9953737 C16.0085383,10.8035094 16.2623768,10.6949501 16.5277774,10.6948872 L24.2751731,10.6948872 C24.8001731,10.6948872 25.2534717,11.0983594 25.276562,11.6233594 C25.288505,11.8884912 25.1915397,12.1469806 25.0081669,12.338845 C24.8247941,12.5307094 24.5709557,12.6392687 24.305555,12.6393316 Z M24.305555,7.77822057 L12.6692706,7.77822057 C12.1442706,7.77822057 11.690972,7.37474836 11.6678817,6.84974837 C11.6559387,6.58461656 11.752904,6.32612709 11.9362767,6.13426272 C12.1196495,5.94239835 12.373488,5.83383906 12.6388886,5.83377617 L24.2751731,5.83377617 C24.8001731,5.83377617 25.2534717,6.23724838 25.276562,6.76224837 C25.288505,7.02738018 25.1915397,7.28586964 25.0081669,7.47773402 C24.8247941,7.66959839 24.5709557,7.77815767 24.305555,7.77822057 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.444444,23.8198869 L19.444444,18.4726648 C19.444444,17.9357213 19.0091653,17.5004426 18.4722218,17.5004426 L1.9444444,17.5004426 C0.870759865,17.5037861 0.00166720794,18.3742367 0,19.4479252 C0,22.5195397 0.35121527,23.7967966 0.878645815,24.7690188 C1.77369788,26.4199736 3.39427076,27.2226647 5.83333321,27.2226647 L20.7618051,27.2226647 C20.8598608,27.2226647 20.948361,27.1638965 20.9862162,27.0734426 C21.0240713,26.9829887 21.0038664,26.8786472 20.9349822,26.8088625 C20.3601558,26.2322132 19.444444,25.4605119 19.444444,23.8198869 Z",
    id: "Path"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReceipt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/receipt.8a0f9df4.svg";
export { ForwardRef as ReactComponent };